"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.List = void 0;
var tslib_1 = require("tslib");
var List_1 = require("@reactionable/core/lib/crud/list/List");
var react_1 = tslib_1.__importDefault(require("react"));
var Table_1 = tslib_1.__importDefault(require("react-bootstrap/Table"));
var react_i18next_1 = require("react-i18next");
function List(_a) {
    var head = _a.head, children = _a.children, props = tslib_1.__rest(_a, ["head", "children"]);
    var t = react_i18next_1.useTranslation().t;
    return (react_1.default.createElement(List_1.List, tslib_1.__assign({}, props, { children: function (data) { return (react_1.default.createElement(Table_1.default, { striped: true, bordered: true, hover: true, responsive: true },
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null, head.map(function (item) {
                    return 'string' === typeof item ? react_1.default.createElement("th", { key: item }, t(item)) : item;
                }))),
            react_1.default.createElement("tbody", null, data.map(function (item) { return children(item); })))); } })));
}
exports.List = List;
//# sourceMappingURL=List.js.map